// AUTO-GENERATED by codegen.ts from the OpenAPI spec + agent-tool-manifest snapshot. Do not edit.
import type { AgentToolDescriptor } from "../common/agent/agentTypes";

export const agentToolCatalog: AgentToolDescriptor[] = [
  {
    "toolName": "listCombinedEventsForBuyer",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister anskaffelser med status og frister",
    "params": [
      {
        "name": "statuses",
        "in": "query",
        "type": "string[]",
        "required": false
      },
      {
        "name": "projectIds",
        "in": "query",
        "type": "string[]",
        "required": false
      },
      {
        "name": "name",
        "in": "query",
        "type": "string",
        "required": false
      },
      {
        "name": "responsiblePersons",
        "in": "query",
        "type": "string[]",
        "required": false
      },
      {
        "name": "limit",
        "in": "query",
        "type": "integer",
        "required": false
      },
      {
        "name": "skip",
        "in": "query",
        "type": "integer",
        "required": false
      },
      {
        "name": "sortBy",
        "in": "query",
        "type": "SourcingEventSortField",
        "required": false
      },
      {
        "name": "sortDirection",
        "in": "query",
        "type": "SortDirection",
        "required": false
      }
    ]
  },
  {
    "toolName": "getSourcingEvent",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer og konfigurasjon for én anskaffelse.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "getBasicSourcingEvent",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter en eldre (grunnleggende) anskaffelse med dens data, spørsmål og status.",
    "appliesToKind": "V1",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "getSourcingEventReadiness",
    "method": "GET",
    "riskTier": "none",
    "description": "Sjekker hva som mangler før en anskaffelse kan publiseres.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "getEvaluation",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter innkomne tilbud med poeng og rangering.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "getBuyerSeV2Questions",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter spørsmål fra leverandører (Q&A).",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "getBuyerAnnouncements",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter kunngjøringer publisert til leverandører.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "getAwardLetters",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter tildelingsbrev (utkast, godkjent, sendt).",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "listContractReports",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister kontrakter",
    "params": [
      {
        "name": "titleFilter",
        "in": "query",
        "type": "string",
        "required": false,
        "description": "Filtrer kontrakter på navn (delstreng, ufølsom for store/små bokstaver)"
      },
      {
        "name": "limit",
        "in": "query",
        "type": "integer",
        "required": false
      }
    ]
  },
  {
    "toolName": "getContract",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer for én kontrakt.",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "listContractMessages",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter meldinger (dialog) på en kontrakt.",
    "params": [
      {
        "name": "contractId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "getMe",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter den innloggede brukeren (navn, roller, organisasjoner).",
    "params": []
  },
  {
    "toolName": "getProjects",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister prosjekter (kan filtreres på navn).",
    "params": [
      {
        "name": "name",
        "in": "query",
        "type": "string",
        "required": false
      },
      {
        "name": "status",
        "in": "query",
        "type": "string",
        "required": false
      },
      {
        "name": "limit",
        "in": "query",
        "type": "integer",
        "required": false
      },
      {
        "name": "skip",
        "in": "query",
        "type": "integer",
        "required": false
      }
    ]
  },
  {
    "toolName": "getProject",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer for ett prosjekt.",
    "params": [
      {
        "name": "projectId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "listNeeds",
    "method": "GET",
    "riskTier": "none",
    "description": "Lister behov (meld inn behov).",
    "params": [
      {
        "name": "status",
        "in": "query",
        "type": "string",
        "required": false
      }
    ]
  },
  {
    "toolName": "getNeed",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter detaljer for ett behov.",
    "params": [
      {
        "name": "needId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "listReceivedBids",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter innkomne tilbud på en V1-anskaffelse.",
    "appliesToKind": "V1",
    "params": [
      {
        "name": "negotiationRound",
        "in": "query",
        "type": "string",
        "required": false
      },
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      }
    ]
  },
  {
    "toolName": "listMyNotifications",
    "method": "GET",
    "riskTier": "none",
    "description": "Henter dine varsler.",
    "params": [
      {
        "name": "limit",
        "in": "query",
        "type": "integer",
        "required": false
      },
      {
        "name": "offset",
        "in": "query",
        "type": "integer",
        "required": false
      },
      {
        "name": "unseen",
        "in": "query",
        "type": "boolean",
        "required": false
      }
    ]
  },
  {
    "toolName": "answerSeV2Question",
    "method": "PATCH",
    "riskTier": "reversible",
    "description": "Svarer på et spørsmål fra en leverandør (privat svar).",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      },
      {
        "name": "questionId",
        "in": "path",
        "type": "string",
        "required": true
      },
      {
        "name": "seV2QuestionPatchDto",
        "in": "body",
        "type": "SeV2QuestionPatchDto",
        "required": true,
        "fields": [
          {
            "name": "answer",
            "type": "string",
            "required": false
          },
          {
            "name": "attachments",
            "type": "SeV2AttachmentInputDto[]",
            "required": false
          }
        ]
      }
    ]
  },
  {
    "toolName": "awardSourcingEvent",
    "method": "POST",
    "riskTier": "binding_statutory",
    "description": "Tildeler anskaffelsen til ett eller flere vinnende tilbud.",
    "appliesToKind": "V2",
    "params": [
      {
        "name": "eventId",
        "in": "path",
        "type": "string",
        "required": true
      },
      {
        "name": "awardSourcingEventRequest",
        "in": "body",
        "type": "AwardSourcingEventRequest",
        "required": true,
        "fields": [
          {
            "name": "winningBidIds",
            "type": "string[]",
            "required": true
          },
          {
            "name": "internalNote",
            "type": "string",
            "required": false
          },
          {
            "name": "eventValue",
            "type": "string",
            "required": false
          }
        ]
      }
    ]
  },
  {
    "toolName": "createSourcingEvent",
    "method": "POST",
    "riskTier": "reversible",
    "description": "Oppretter en ny anskaffelse (utkast).",
    "params": [
      {
        "name": "createSourcingEventV2Request",
        "in": "body",
        "type": "CreateSourcingEventV2Request",
        "required": true,
        "fields": [
          {
            "name": "title",
            "type": "string",
            "required": true
          },
          {
            "name": "description",
            "type": "string",
            "required": false
          },
          {
            "name": "estimatedValue",
            "type": "string",
            "required": false
          },
          {
            "name": "contractNature",
            "type": "string",
            "required": false
          }
        ]
      }
    ]
  }
];
